import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 80,
    marginBottom: 56,
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
      marginBottom: 32,
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  title: {
    marginBottom: 18,
  },
}));

const CancerEvaluationReHeader = ({ cancer = "폐암", sub = false }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      className={classes.header}
    >
      <Typography variant="h2" className={classes.title}>
        사용 후 평가 설문 결과표
      </Typography>
      {/* {sub && (
        <Typography variant="h4" color="textSecondary" align="center">
          귀하께서는 “폐암 검진, 받는 것이 좋을까요?”에 대한 시청을
          마치셨습니다.
          <br />
          시청하신 자료에 대한 설문에 응답을 부탁드립니다.
        </Typography>
      )} */}
    </Grid>
  );
};

export default CancerEvaluationReHeader;
